import * as React from "react";
import { Link, Typography } from "@mui/material";
import moment from "moment";
import dayjs from "dayjs";

const CommonFooter = (props) => {
  return (
    <Typography
      sx={{ py: 1.5,  fontSize: { xs: '12px', sm: '14px' }, backgroundColor: "#F4F7FC", pt: 5 }}
      // mt: 5
      textAlign="center"
    >
      <Typography variant="body2" color="text.secondary" sx={{
          fontSize: { xs: '12px', sm: '14px' }, 
        }}>
        © Copyright {dayjs().format('YYYY')}. All Rights Reserved by{" "}
        <Link
          href="https://prosculpt.co"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          color="inherit"
          sx={{
            fontSize: { xs: '14px', sm: '18px' }, 
          }}
        >
          prosculpt.co
        </Link>
      </Typography>

    </Typography>
  );
};

export default CommonFooter;
